module.exports = __webpack_public_path__ + "static/media/chileatiende.a6bdfab9.webp";